import type { StoryMeta } from "@/data/stories";
import type { Tone } from "@/components/app/Playful";

import { BookOpen } from "lucide-react";
import { cn } from "@/lib/utils";
import { tones } from "@/components/app/Playful";

export const storyTone: Record<StoryMeta["theme"], Tone> = {
  neeti: "mango",
  pashu: "mint",
  agam: "lavender",
  jeevan: "peach",
};

/** The story photo, or a themed cover with the Prakrit title while it has none. */
export function StoryCover({ story, className, eager }: { story: StoryMeta; className?: string; eager?: boolean }) {
  const tone = tones[storyTone[story.theme]];
  if (story.image) {
    return (
      <img
        src={story.image}
        alt={story.hi}
        loading={eager ? "eager" : "lazy"}
        className={cn("h-full w-full object-cover", className)}
      />
    );
  }
  return (
    <div
      role="img"
      aria-label={story.hi}
      className={cn("flex h-full w-full flex-col items-center justify-center gap-2 bg-gradient-to-br p-4 text-center", tone.tile, className)}
    >
      <BookOpen className="size-6 text-white/90" aria-hidden />
      <span className="prakrit text-2xl font-extrabold text-white drop-shadow-sm">{story.title}</span>
    </div>
  );
}
